import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={12} height={8} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M11.03.222a.563.563 0 010 1.125H.903a.563.563 0 010-1.125H11.03zM11.03 3.436a.563.563 0 010 1.125H.903a.563.563 0 010-1.125H11.03zM11.03 6.648a.563.563 0 010 1.125H.903a.563.563 0 010-1.125H11.03z" fill="#A9A9A9" /></svg>;
}
export default SvgComponent;